module.exports = __webpack_public_path__ + "img/er.804cbebd.svg";